export default "__VITE_ASSET__DsxgqA_h__"